/*!
 * KoliBri - The accessible HTML-Standard
 */
import { b as watchValidator } from './common-D-vggmh2.js';

const orientationPropTypeOptions = ['horizontal', 'vertical'];
const validateOrientation = (component, value, defaultValue = 'horizontal') => {
    watchValidator(component, `_orientation`, (value) => typeof value === 'string' && orientationPropTypeOptions.includes(value), new Set([`KoliBriOrientation {${orientationPropTypeOptions.join(', ')}`]), value, {
        defaultValue,
    });
};

export { validateOrientation as v };
//# sourceMappingURL=orientation-CfF8dz-f.js.map

//# sourceMappingURL=orientation-CfF8dz-f.js.map